export default "__VITE_ASSET__BGZFjpY8__"